module.exports = __webpack_public_path__ + "static/media/guide.18024dac.png";